import React from 'react'
import MyResult from '../../components/MyResult'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom';

export default function Queuing({currStep}) {

  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/m2d/history");
  };

  return (
    <>
      <MyResult
        title={
          currStep === "Queuing"
            ? "Your data is waiting to be processed..."
            : "Your data is processing..."
        }
        subTitle="Please wait patiently for your data to be processed."
        extra={[
          <Button key="1" variant="contained" onClick={handleBack}>
            Go back to your account
          </Button>
        ]}
      />
    </>
  )
}
